import React from 'react';
import ReactDOM from 'react-dom';
import axios from 'axios';
import Keycloak from 'keycloak-js';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import store from './reduxFiles/store';
import Full from './containers/Full/';
import { IntlConsumer, IntlProvider } from './IntlContext';
import Public from './containers/Public/Public';
import { setKeycloakInstance } from './util/keycloakClient';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;


let userOrdinal = window.sessionStorage.getItem('u');
userOrdinal = userOrdinal || window.localStorage.getItem('lastSelectedU');

axios.defaults.baseURL = window.location.pathname.startsWith('/public')
    ? process.env.REACT_APP_EUNSA_BACKEND_URL
    : process.env.REACT_APP_EUNSA_BACKEND_URL + '/u/' + (userOrdinal || 0);

axios.interceptors.request.use(config => {
    if (window.location.pathname.startsWith('/public')) {
        delete config.headers.Authorization;
        return config;
    }
    config.headers = {
        ...config.headers,
        ...{
            'Content-Type': 'application/json',
            Accept: 'application/json',
            // eslint-disable-next-line no-use-before-define
            Authorization: 'BEARER ' + kc.token
        }
    };
    return config;
});

const keycloakConfigValue = process.env.REACT_APP_EUNSA_KEYCLOAK_JSON_URL;
let keycloakConfig = keycloakConfigValue;

try {
    keycloakConfig = JSON.parse(keycloakConfigValue);
} catch (e) {
    // Keycloak JS also accepts a URL to a JSON configuration file.
    keycloakConfig = keycloakConfigValue;
}
const kc = Keycloak(keycloakConfig);
setKeycloakInstance(kc);

// javne stranice pozivaju prijavu preko ovog helpera (dugme "Prijava")
window.eunsaLogin = () => kc.login({ redirectUri: window.location.origin + '/' });

kc.init({
    onLoad: 'check-sso',
    checkLoginIframe: process.env.NODE_ENV !== 'development'
}).success(authenticated => {
    if (window.location.pathname.startsWith('/public')) {
        ReactDOM.render(
            <Provider store={store}>
                <IntlProvider public>
                    <BrowserRouter>
                        <IntlConsumer>
                            {({ switchToEnglish, switchToBosnian, switchToCroatian }) => (
                                <Public switchToCroatian={switchToCroatian} switchToBosnian={switchToBosnian} />
                            )}
                        </IntlConsumer>
                    </BrowserRouter>
                </IntlProvider>
            </Provider>
            , document.getElementById('root')
        );
        return;
    }
    if (authenticated) {
	    setInterval(() => {
            kc.updateToken(10).error(() => kc.logout());
        }, 10000);
        ReactDOM.render(
            <Provider store={store}>
                <IntlProvider>
                    <BrowserRouter>
                        <IntlConsumer>
                            {({ switchToEnglish, switchToBosnian, switchToCroatian }) => (
                                <Full switchToCroatian={switchToCroatian} switchToBosnian={switchToBosnian} />
                            )}
                        </IntlConsumer>
                    </BrowserRouter>
                </IntlProvider>
            </Provider>
            , document.getElementById('root')
        );
        // registerServiceWorker();
    } else {
        // show possibly other page here...
        kc.login();
    }
});



// WEBPACK FOOTER //
// ./src/index.js